import Box from '@material-ui/core/Box';
import React from 'react';
import posed, { PoseGroup } from 'react-pose';
import styled from 'styled-components';

import { MONITOR_STATUS_ICONS, STATUS_LABELS as PATIENT_STATUS_LABELS } from '../../../entities/patient/enums';
import { STATUS_LABELS as ROOM_STATUS_LABELS } from '../../../entities/room/enums';
import { Status } from './common';
import responsiveStyles from '@/se/utilities/responsive';

const responsive = responsiveStyles;

const Wrapper = styled.div`
  min-height: 9.75rem;
  margin: 0 auto;
  display: ${props => (props.noIcon ? 'none' : 'initial')};

  ${responsive.sm.andSmaller`
    display: none;
  `};
`;

const Meter = posed.img({
  enter: {
    opacity: 1,
    transition: {
      duration: 500,
      ease: [0.0, 0.01, 0.01, 0.99],
      delay: 500,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 500,
      ease: [0.0, 0.01, 0.01, 0.99],
    },
  },
});

const CurrentProgress = styled.div`
  display: flex;
  flex-direction: column;
`;

const StatusContainer = styled.div`
  text-align: center;
  margin-top: auto;
`;

const CurrentStatus = ({ status }) => (
  <StatusContainer>
    <Status>{status}</Status>
  </StatusContainer>
);

const ProcedureProgress = ({ status, noIcon = undefined }) => {
  const statusLabel = PATIENT_STATUS_LABELS[status] || ROOM_STATUS_LABELS[status];

  return (
    <Box style={{ display: 'flex', flexDirection: 'column' }}>
      <Wrapper noIcon={noIcon}>
        <PoseGroup animateOnMount flipMove={true}>
          <Meter key={status} src={MONITOR_STATUS_ICONS[status]} flipMove />
        </PoseGroup>
      </Wrapper>
      <CurrentStatus status={statusLabel} />
    </Box>
  );
};

export default ProcedureProgress;
